// Vendors
import $ from 'jquery';
import _ from 'lodash';
import { AJAX_URL } from '../config';

// Config
const container = '.newsroom-stories';
const grid = '.newsroom-stories__grid';
const pagination = '.newsroom-stories__pagination';
const tab = '.newsroom-stories__tab';
const searchInput = '.newsroom-stories__search-input';
const activeTabClass = 'newsroom-stories__tab--active';
const loadingClass = 'newsroom-stories--loading';

// Current filter state. Categories are fixed per page and set server-side — the
// tabs filter by tag within that pool.
const state = {
  tag: 'all',
  search: '',
  page: 1,
  page_id: $(container).data('page-id') || ''
};

function fetchStories() {
  $(container).addClass(loadingClass);

  $.ajax({
    type: 'POST',
    url: `${AJAX_URL}wlPostAjaxNewsroomStories`,
    data: state,
    dataType: 'json',
    encode: true,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    success: (res) => {
      $(grid).html(res.data.cards);
      $(pagination).html(res.data.pagination);
    },
    complete: () => {
      $(container).removeClass(loadingClass);
    }
  });
}

if ($(container).length) {
  // Tag tabs
  $(container).on('click', tab, (event) => {
    const self = $(event.currentTarget);

    state.tag = self.data('tag');
    state.page = 1;

    $(tab).removeClass(activeTabClass);
    self.addClass(activeTabClass);

    fetchStories();
  });

  // Search (debounced)
  $(container).on(
    'input',
    searchInput,
    _.debounce((event) => {
      state.search = $(event.currentTarget).val();
      state.page = 1;
      fetchStories();
    }, 300)
  );

  // Pagination
  $(container).on('click', '[data-page]', (event) => {
    const self = $(event.currentTarget);

    if (self.prop('disabled')) {
      return;
    }

    state.page = parseInt(self.data('page'), 10);
    fetchStories();

    // Scroll back to the top of the grid
    const offset = $(container).offset().top - 100;
    $('html, body').animate({ scrollTop: offset }, 300);
  });
}
